import { useCallback, useEffect, useRef } from "react";
function memoizeOneDeepEquality(a, b) {
  if (a === b) return true;
  if (typeof a !== typeof b) return false;
  if (Array.isArray(a) && Array.isArray(b) && a.length !== b.length) return false;
  return JSON.stringify(a) === JSON.stringify(b);
}
function useMemoizeOne(action, equals) {
  const rParse = useRef({
    action,
    ...equals,
    lastInputValue: void 0,
    lastOutputValue: void 0
  });
  useEffect(() => void (rParse.current = { ...rParse.current, action }), [action]);
  return useCallback((inputValue, customEquals) => {
    const { lastInputValue, lastOutputValue, action: action2, equals: equals2, shallowEquality = false } = rParse.current;
    const testEquality = customEquals ?? equals2 ?? shallowEquality ? Object.is : memoizeOneDeepEquality;
    if (testEquality(inputValue, lastInputValue)) return lastOutputValue;
    const outputValue = action2(inputValue);
    rParse.current.lastInputValue = inputValue;
    rParse.current.lastOutputValue = outputValue;
    return outputValue;
  }, []);
}
export {
  memoizeOneDeepEquality,
  useMemoizeOne
};
//# sourceMappingURL=useMemoizeOne.js.map
